export default __webpack_public_path__ + "5bf04f461d3706d446e7c3c42b4f81a3.svg";